export function expandText() {
    for(let el of document.querySelectorAll('.fulltext')){
        el.addEventListener("click", () => {
            el.classList.toggle("active");
        });
    }
}